import React from 'react'
import './BuyerSignUpBtn.css'

export const BuyerSignUpBtn = () => {
  return (
    <>
    <button className='buyer_signup_btn'>Create an Account</button>
    </>
  )
}
